import './index.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { _404 } from './elements/404';
import { MpanAssignmentPage } from './pages/MpanAssignmentPage';
import { PageContainer } from '@portal_components/components/PageContainer';
import { PortalFooter } from '@portal_components/components/PortalFooter';
import { PortalHeader } from '@portal_components/components/PortalHeader';
import { DetailsSearchPage } from './pages/DetailsSearchPage';
import { EditSiteDetailsPage } from './pages/EditSiteDetailsPage';
import { BulkAssignPage } from './pages/BulkAssignPage';
import { useUserInfo } from './hooks/useUserInfo';
import { ExceptionsPage } from './pages/ExceptionsPage';
import { HandoverExceptionsPage } from './pages/HandoverExceptionsPage';
import { NoAppointmentExceptionsPage } from './pages/NoAppointmentExceptionsPage';

function App() {
  const { isUserInfoLoading, userInfo } = useUserInfo();

  const router = createBrowserRouter([
    {
      path: '',
      element: <PageContainer className="col-span-12 md:col-span-10 lg:col-span-8 xl-col-span-8 2xl:col-span-6" />,
      children: [
        {
          path: '',
          element: <MpanAssignmentPage />
        },
        {
          path: 'edit/:customerGroupId/:contractId/:mprn',
          element: <EditSiteDetailsPage />
        },
        {
          path: 'bulk-assign',
          element: <BulkAssignPage />
        },
        {
          path: 'exceptions/:handoverFileName',
          element: <HandoverExceptionsPage />
        },
        {
          path: 'no-appointment-exceptions/:handoverFileName',
          element: <NoAppointmentExceptionsPage />
        }
      ]
    },
    {
      path: 'exceptions',
      element: <PageContainer className="h-[60vh] col-span-12 md:col-span-10 lg:col-span-8 xl-col-span-8 2xl:col-span-6" />,
      children: [
        {
          path: '',
          element: <ExceptionsPage />
        }
      ]
    },
    {
      path: 'search',
      element: <PageContainer className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12 2xl:col-span-11" />,
      children: [
        {
          path: '',
          element: <DetailsSearchPage />
        }
      ]
    },
    {
      path: '404',
      element: <_404 />
    }
  ]);

  return (
    <div className="flex flex-col">
      <PortalHeader title="NHH Portfolio Portal" applications={userInfo?.applications} userEmail={userInfo?.user} navigate={router.navigate} />
      {isUserInfoLoading && <div className="flex flex-row justify-center">Loading User Info...</div>}
      {userInfo && <RouterProvider router={router} />}
      <PortalFooter />
    </div>
  );
}

export default App;
